import {
  Redirect,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import Footer from "../Footer";
import HeaderInfoBar from "../HeaderInfoBar";
import HealthHeader from "../HealthHeader";
import { ScrollToHash } from "../ScrollToHash";
import { useEffect } from "react";
import { getSession } from "../../componentsUpdated/redux/actions/authActions";

export const WebsiteLayout = ({ className, children }) => {
  const location = useLocation();
  const { token } = getSession();

  useEffect(() => {
    if (
      !["/share_payment", "/sharedLogin", "cartLogin"].includes(
        location.pathname
      )
    ) {
      sessionStorage.removeItem("payment_user_details");
      sessionStorage.removeItem("orderId");
    }
  }, [location]);

  if (token) {
    if (!location.pathname.includes("/dashboard")) {
      return <Redirect to={"/dashboard"} replace={true} />;
    }
  } else {
    if (location.pathname.includes("/dashboard")) {
      return <Redirect to={"/"} replace={true} />;
    }
  }

  return (
    <div>
      <ScrollToHash />
      <HeaderInfoBar />
      <HealthHeader />
      <div className={`mx-auto  h-full ${className}`}>{children}</div>
      <Footer />
    </div>
  );
};
